export default __webpack_public_path__ + "static/business-opportunities-page-84ca0ec2e00568a8fff010b0daaeba72.png";